module.exports = __webpack_public_path__ + "img/info.3c6b10c7.png";